<div *ngIf="contextIdDto">
    <app-task-list #taskListRef (toggleView)="showTaskBoard()"  *ngIf="!showBoard" [contextIdDto]="contextIdDto" [eventBus]="eventBus"></app-task-list>
    <app-task-board #taskBoardRef (toggleView)="showTaskList()" *ngIf="showBoard"  [contextIdDto]="contextIdDto" [eventBus]="eventBus"></app-task-board>
</div>

